import { render, staticRenderFns } from "./CarouselImage.vue?vue&type=template&id=3ac6be19&"
import script from "./CarouselImage.vue?vue&type=script&lang=js&"
export * from "./CarouselImage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports